import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { change, formValueSelector } from 'redux-form';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import { removeListPhotos } from '../../actions/manageListPhotos';
import { fileuploadDir } from '../../config';
import { photosShow } from '../../helpers/photosShow';

import s from './PhotosList.css';

class PhotosList extends Component {

  static propTypes = {
    removeListPhotos: PropTypes.any.isRequired,
    listId: PropTypes.number.isRequired,
    listPhotos: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      listId: PropTypes.number.isRequired
    }))
  };

  static defaultProps = {
    listPhotos: []
  };

  changeCoverPhoto = (id) => {
    const { change } = this.props;
    change("ListPlaceStep2", 'coverPhoto', id);
  }

  render() {
    const { removeListPhotos, listPhotos, coverPhoto, onAddMore } = this.props;

    let path = photosShow(fileuploadDir);

    if (!listPhotos || listPhotos.length === 0) return null;

    return (
      <div className={s.photoRowGrid}>
        {
          listPhotos?.map((item, key) => {
            return (
              <div key={key} className={s.photoThumbWrap}>
                <div
                  className={s.photoThumbImg}
                  style={{ backgroundImage: `url(${path}x_medium_${item?.name})` }}
                />
                <button
                  type="button"
                  className={s.photoRemoveBtn}
                  onClick={() => removeListPhotos(item?.listId, item?.name, true)}
                  aria-label="Eliminar foto"
                >
                  ×
                </button>
              </div>
            );
          })
        }
        {/* Tarjeta "Agregar más" */}
        <button
          type="button"
          className={s.photoAddMoreCard}
          onClick={onAddMore}
        >
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="26" height="26" rx="5" stroke="#90CAF9" strokeWidth="1.8"/>
            <path d="M6 20l5-7 5 6 3-3.5 5 4.5" stroke="#90CAF9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="22" cy="8" r="5" fill="#2196F3"/>
            <path d="M22 5.5v5M19.5 8h5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          <span>Agregar más</span>
        </button>
      </div>
    );
  }
}

const selector = formValueSelector('ListPlaceStep2');

const mapState = (state) => ({
  listPhotos: state?.location?.listPhotos,
  coverPhoto: selector(state, 'coverPhoto'),
});

const mapDispatch = {
  removeListPhotos,
  change
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(PhotosList)));